import React, {useEffect, useState} from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../../../../components/icon';
import {videoPopup} from '../../../../../../../actions/popupActions';
import {useDispatch, useSelector} from 'react-redux';
import {API_ROOT} from '../../../../../../utils';
import {postEngagement} from '../../../../../../../actions/engagementActions';
import './index.css';
import Button from '../../../../../../components/button';

function DirectorySyncAccessDenied (props) {

	const {
		profile,
		selectedContactsGroup
	} = props;

	const { t } = useTranslation();

	const [video, setVideo] = useState({
		id: 'Dr1wBIrhLzo',
		preview: '/img/getting-started-1.jpg'
	});

	const language = useSelector(state => state.languageReducer.language);

	const dispatch = useDispatch();

	useEffect(() => {
		switch (language) {
			case 'fr' :
				setVideo({
					id: '7yg9nr41gTw',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-fr.jpg'
				});
				break;
			case 'es' :
				setVideo({
					id: 'iGwo6QCf6bc',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-es.jpg'
				});
				break;
			default :
				setVideo({
					id: 'Dr1wBIrhLzo',
					preview: API_ROOT + '/img/7-reasons-to-upgrade-en.jpg'
				});
				break;
		}
	}, [language]);

	const handlePlay = () => {
		dispatch(postEngagement(58, new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
		}).format()));

		dispatch(videoPopup(video.id));
	};

	const handleUpgrade = () => {
		dispatch(postEngagement(59, new Intl.DateTimeFormat('fr-FR', {
			day: '2-digit',
			month: '2-digit',
			year: '2-digit',
			hour: '2-digit',
			minute: '2-digit',
			second: '2-digit',
		}).format()));
	};

	if(profile.domain.plan !== "FREE_EDITION" && profile.domain.plan !== "BUSINESS") {
		return (
			<div className="directory-sync-access-denied">
				<h2>{t('upgradeToBusinessTitle')}</h2>
				<p>{t('upgradeToBusinessContent')}</p>
				<div>
					<button className="video-button" onClick={handlePlay}>
						<Icon name="play-circle" />
						<img data-video={video.id} className="d-block" src={video.preview} width="300" alt=""/>
					</button>
				</div>
				<div className="text-center">
					<Button onClick={ handleUpgrade } role="button" className="btn-primary text-nowrap" href={`/payment/upgrade`} target="_blank" rel="noreferrer">{t("textUpgradeNow")}</Button>
				</div>
			</div>
		)
	} else {
		if(selectedContactsGroup.activeDirectory === true) {
			return (
				<div className="directory-sync-access-denied">
					<div className="d-flex align-items-top">
						<svg className="directory-contact-icon mr-3" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" xmlSpace="preserve">
							<path fill="#001593" d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
							<path d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z" fill="#FFF"/>
						</svg>
						<div>
							<h2 className="mr-3">{t("textDirectorySyncAccessDeniedHeader")}</h2>
							<p className="lead text-info">{selectedContactsGroup.name}</p>
						</div>
					</div>

					<div className="px-5 py-3">
						<h3 className="text-success">Directory enabled</h3>
						<p>Please ask your administrator to share the directory label</p>
					</div>
				</div>
			)
		} else {
			return (
				<div className="directory-sync-access-denied">
					<div className="d-flex align-items-top">
						<svg className="directory-contact-icon mr-3" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" xmlSpace="preserve">
							<path fill="#001593" d="M24 0C10.745 0 0 10.745 0 24c0 13.255 10.745 24 24 24 13.255 0 24 -10.745 24 -24C48 10.745 37.255 0 24 0z"/>
							<path d="M11.654 13.708h2.483v25.362h-2.483zm22.209 0h2.482v25.362h-2.482zm-18.284 25.362H20.554V34.673h6.892v4.397h4.974V8.93H15.579v30.139zm12.907 -28.126h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.758h-2.487v-2.758zm0 4.243h2.487v2.764h-2.487v-2.764zm0 4.249h2.487v2.764h-2.487v-2.764zm0 4.778h2.487v2.758h-2.487v-2.758zm-3.82 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758zm-3.825 -17.519h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.758h-2.483v-2.758zm0 4.243h2.483v2.764h-2.483v-2.764zm0 4.249h2.483v2.764h-2.483v-2.764zm0 4.778h2.483v2.758h-2.483v-2.758z" fill="#FFF"/>
						</svg>
						<div>
							<h2 className="mr-3">{t("textDirectorySyncAccessDeniedHeader")}</h2>
							<p className="lead text-info">{selectedContactsGroup.name}</p>
						</div>
					</div>

					<div className="px-5 py-3">
						<h3 className="text-danger">{t("titleDirectoryDisabled")}</h3>
						<p>{t("textDirectoryAskAdmin")}</p>
					</div>
				</div>
			)
		}
	}


}

export default DirectorySyncAccessDenied;
